<script setup>
import { useAuthStore } from "@stores/auth";
import { useSettingsStore } from "@stores/settings";
import { usePrefetchImages } from "@composables/helpers/usePrefetchImages";

const config = useRuntimeConfig();
const CFIMAGE_URL = config.public.CLOUDFLARE_HOST_URL;

const authStore = useAuthStore();
const settingsStore = useSettingsStore();
const { prefetchImages } = usePrefetchImages();

const onClose = () => {
  if (authStore.currentField === "register" && settingsStore.settings.bonus_register !== "false") {
    authStore.modalOpen("close");
  } else {
    authStore.modalClose();
  }
};

const modalBannerUrl = ref(null);

const updateModalBannerUrl = async () => {
  let url = null;

  const getUrl = (banner) => {
    if (!banner) return null;
    if (banner[0]?.image_cf) return CFIMAGE_URL + banner[0].image_cf + "/bannerModal";
    return banner[0]?.src || null;
  };

  if (authStore.currentField === "login") {
    url = getUrl(settingsStore.state.modalBanners?.login);
  } else if (authStore.currentField === "register") {
      url = getUrl(settingsStore.state.modalBanners?.register);
  } else if (authStore.currentField === "recover") {
    url = getUrl(settingsStore.state.modalBanners?.password_recovery);
  } else if (authStore.currentField === "close") {
    url = getUrl(settingsStore.state.modalBanners?.register_cancel);
  }

  if (url) {
    try {
      prefetchImages([url]);
      modalBannerUrl.value = url;
    } catch (error) {
      console.error("Error prefetching image:", error);
      modalBannerUrl.value = null;
    }
  } else {
    modalBannerUrl.value = null;
  }
};

onMounted(() => {
  watch(
    () => authStore.currentField,
    updateModalBannerUrl,
    { immediate: true }
  );
});
</script>
<template>
    <BaseModal
      :show="authStore.state.displayModal"
      :modal-banner-url="modalBannerUrl"
      @close="onClose"
      class="relative flex h-full w-full flex-col overflow-y-auto text-white xl:h-auto xl:max-w-sm xl:rounded-md"
    >
      <!-- TODO: add transition in these components -->
      <transition name="fade">
        <div>
          <AuthLogin v-if="authStore.currentField === 'login'" />
          <AuthRegister v-if="authStore.currentField === 'register'" />
          <AuthRecover v-if="authStore.currentField === 'recover'" />
          <AuthClose v-if="authStore.currentField === 'close'" />
        </div>
      </transition>
    </BaseModal>
</template>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
